export const Config = {
	apiUrl: "https://keolis-api.lijnenkaart.nl/v1",
	apiKey: "5379bcfa-a603-42af-858c-b884ed483049",
	siteUrl: "https://reizen.keolis.nl",
};
